import { Job } from '@vromo/models';
import { isValidEmail } from '@vromo/models/helpers';
import { parsePhoneNumber } from 'libphonenumber-js';
import { isNumber } from "lodash"



export type JobValidationOptions =
    {
        minTasks?: number,
        requiredFields?: ('name' | 'contact')[]
    }
export type JobValidationField = 'tasks' | 'location' | 'name' | 'email' | 'phone' | 'all'
export type JobValidationError = {
    field: JobValidationField
    message: string;
    ix?: number
}


const defaultOptions: JobValidationOptions = {
    minTasks: 1,
    requiredFields: [] = []
};


export function validateJob(job: Job, customOptions?: JobValidationOptions
): JobValidationError[] {
    const options = { ...defaultOptions, ...customOptions };
    const errors: JobValidationError[] = [];

    if (options.requiredFields?.includes('name')) {
        if (!job.name)
            errors.push({ field: 'name', message: 'This field is required' });
    }

    if (options.minTasks && (job.tasks!.length < options.minTasks))
        errors.push({
            field: 'tasks',
            message: `A job must have at least ${options.minTasks} tasks`
        });

    // All tasks must have a lat/lng and address and description
    job.tasks!.forEach((task, ix) => {
        if (!isNumber(task.zone?.coords?.lat) || !isNumber(task.zone?.coords?.lon) || !task.zone?.address) {
            errors.push({
                field: 'location',
                ix,
                message: "We weren't able to find this location"
            });
        }
    });

    if (options.requiredFields?.includes('contact')) {
        if (!job.contact?.name)
            errors.push({ field: 'name', message: 'Customer name is required' });
        if (!job.contact?.email)
            errors.push({ field: 'email', message: 'Customer email is required' });
        if (!job.contact?.phone)
            errors.push({ field: 'phone', message: 'Customer phone is required' });
    }

    if (job.contact?.phone && job.contact.phone.length >= 0) {
        try {
            if (!parsePhoneNumber(job.contact?.phone).isValid()) {
                errors.push({
                    field: 'phone',
                    message: 'You must enter a valid international phone number'
                });
            }
        } catch (e) {
            errors.push({
                field: 'phone',
                message: 'You must enter a valid international phone number'
            });
        }
    }
    if (job.contact?.email && job.contact.email.length >= 0) {
        if (!isValidEmail(job.contact.email)) {
            errors.push({
                field: 'email',
                message: 'You must enter a valid email address'
            });
        }
    }

    return errors;
}
